export const template_auto_position_x_auto_cir = {
  'name': 'Cấu hình duy trì vị trí  + Tối ưu CIR',
  'level': 'campaign',
  'advanced_day': 'remain',
  'advanced_day_number': null,
  'radio': '1',
  'time': '',
  'start_time': '',
  'end_time': '',
  'times': [],
  'not_in': {
    'action_campaign': '',
    'update_price_type_campaign': 'value',
    'update_price_value_campaign': '',
    'update_min_price_campaign': null,
    'update_max_price_campaign': null,
    'default_cpc_campaign': '',
    'cpc_range_campaign': null,
    'cpc_type_campaign': 'campaign',
    'action_match_type_0': '',
    'update_price_type_match_type_0': 'value',
    'update_price_value_match_type_0': '',
    'update_min_price_match_type_0': null,
    'update_type_min_price_match_type_0': 'value',
    'update_value_min_price_match_type_0': null,
    'update_max_price_match_type_0': null,
    'update_type_max_price_match_type_0': 'value',
    'update_value_max_price_match_type_0': null,
    'default_cpc_match_type_0': '',
    'cpc_range_match_type_0': null,
    'cpc_type_match_type_0': 'keyword',
    'action_match_type_1': '',
    'update_price_type_match_type_1': 'value',
    'update_price_value_match_type_1': '',
    'update_min_price_match_type_1': null,
    'update_type_min_price_match_type_1': 'value',
    'update_value_min_price_match_type_1': null,
    'update_max_price_match_type_1': null,
    'update_type_max_price_match_type_1': 'value',
    'update_value_max_price_match_type_1': null,
    'default_cpc_match_type_1': '',
    'cpc_range_match_type_1': null,
    'cpc_type_match_type_1': 'keyword',
    'action_placement_2': '',
    'update_price_type_placement_2': 'value',
    'update_price_value_placement_2': '',
    'update_min_price_placement_2': null,
    'update_type_min_price_placement_2': 'value',
    'update_value_min_price_placement_2': null,
    'update_max_price_placement_2': null,
    'update_type_max_price_placement_2': 'value',
    'update_value_max_price_placement_2': null,
    'default_cpc_placement_2': '',
    'cpc_range_placement_2': null,
    'cpc_type_placement_2': 'keyword',
    'action_placement_5': '',
    'update_price_type_placement_5': 'value',
    'update_price_value_placement_5': '',
    'update_min_price_placement_5': null,
    'update_type_min_price_placement_5': 'value',
    'update_value_min_price_placement_5': null,
    'update_max_price_placement_5': null,
    'update_type_max_price_placement_5': 'value',
    'update_value_max_price_placement_5': null,
    'default_cpc_placement_5': '',
    'cpc_range_placement_5': null,
    'cpc_type_placement_5': 'keyword'
  },
  'condition_action_list': [{
    'condition_group': [{
      'condition_list': [{
        'label': 'avg_rank',
        'expression': '>',
        'value': '0',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'avg_rank',
        'expression': '<',
        'value': '6',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'broad_cir',
        'expression': '>',
        'value': '0',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'broad_cir',
        'expression': '<',
        'value': '13',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }]
    }],
    'condition_list': [],
    'action': '',
    'update_price_type': 'value',
    'update_price_value': '',
    'default_cpc': '',
    'cpc_range': null,
    'error_msg': '',
    'success_msg': '',
    'action_campaign': '',
    'update_price_type_campaign': 'value',
    'update_price_value_campaign': '',
    'update_min_price_campaign': null,
    'update_max_price_campaign': null,
    'default_cpc_campaign': '',
    'cpc_range_campaign': null,
    'cpc_type_campaign': 'campaign',
    'action_match_type_0': 'increase',
    'update_price_type_match_type_0': 'value',
    'update_price_value_match_type_0': '80',
    'update_min_price_match_type_0': null,
    'update_type_min_price_match_type_0': 'value',
    'update_value_min_price_match_type_0': null,
    'update_max_price_match_type_0': '2500',
    'update_type_max_price_match_type_0': 'value',
    'update_value_max_price_match_type_0': null,
    'default_cpc_match_type_0': '',
    'cpc_range_match_type_0': null,
    'cpc_type_match_type_0': 'keyword',
    'action_match_type_1': 'increase',
    'update_price_type_match_type_1': 'value',
    'update_price_value_match_type_1': '80',
    'update_min_price_match_type_1': null,
    'update_type_min_price_match_type_1': 'value',
    'update_value_min_price_match_type_1': null,
    'update_max_price_match_type_1': '2000',
    'update_type_max_price_match_type_1': 'value',
    'update_value_max_price_match_type_1': null,
    'default_cpc_match_type_1': '',
    'cpc_range_match_type_1': null,
    'cpc_type_match_type_1': 'keyword',
    'action_placement_2': 'increase',
    'update_price_type_placement_2': 'value',
    'update_price_value_placement_2': '10',
    'update_min_price_placement_2': null,
    'update_type_min_price_placement_2': 'value',
    'update_value_min_price_placement_2': null,
    'update_max_price_placement_2': '1250',
    'update_type_max_price_placement_2': 'value',
    'update_value_max_price_placement_2': null,
    'default_cpc_placement_2': '',
    'cpc_range_placement_2': null,
    'cpc_type_placement_2': 'keyword',
    'action_placement_5': 'increase',
    'update_price_type_placement_5': 'value',
    'update_price_value_placement_5': '10',
    'update_min_price_placement_5': null,
    'update_type_min_price_placement_5': 'value',
    'update_value_min_price_placement_5': null,
    'update_max_price_placement_5': '1250',
    'update_type_max_price_placement_5': 'value',
    'update_value_max_price_placement_5': null,
    'default_cpc_placement_5': '',
    'cpc_range_placement_5': null,
    'cpc_type_placement_5': 'keyword'
  }, {
    'condition_group': [{
      'condition_list': [{
        'label': 'avg_rank',
        'expression': '>',
        'value': '5',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'broad_cir',
        'expression': '>',
        'value': '12',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }]
    }],
    'condition_list': [{
      'label': '',
      'expression': '',
      'value': '',
      'value_p': '',
      'value_t': [],
      'match_type': 'all',
      'post_expression': '&&',
      'level': '',
      'time': '',
      'time_range': null
    }],
    'action': '',
    'update_price_type': 'value',
    'update_price_value': '',
    'default_cpc': '',
    'cpc_range': null,
    'error_msg': '',
    'success_msg': '',
    'action_campaign': '',
    'update_price_type_campaign': 'value',
    'update_price_value_campaign': '20',
    'update_min_price_campaign': null,
    'update_max_price_campaign': null,
    'default_cpc_campaign': '',
    'cpc_range_campaign': null,
    'cpc_type_campaign': 'campaign',
    'action_match_type_0': 'reduce',
    'update_price_type_match_type_0': 'value',
    'update_price_value_match_type_0': '20',
    'update_min_price_match_type_0': '500',
    'update_type_min_price_match_type_0': 'value',
    'update_value_min_price_match_type_0': null,
    'update_max_price_match_type_0': null,
    'update_type_max_price_match_type_0': 'value',
    'update_value_max_price_match_type_0': null,
    'default_cpc_match_type_0': '',
    'cpc_range_match_type_0': null,
    'cpc_type_match_type_0': 'keyword',
    'action_match_type_1': 'reduce',
    'update_price_type_match_type_1': 'value',
    'update_price_value_match_type_1': '20',
    'update_min_price_match_type_1': '500',
    'update_type_min_price_match_type_1': 'value',
    'update_value_min_price_match_type_1': null,
    'update_max_price_match_type_1': null,
    'update_type_max_price_match_type_1': 'value',
    'update_value_max_price_match_type_1': null,
    'default_cpc_match_type_1': '',
    'cpc_range_match_type_1': null,
    'cpc_type_match_type_1': 'keyword',
    'action_placement_2': 'reduce',
    'update_price_type_placement_2': 'value',
    'update_price_value_placement_2': '20',
    'update_min_price_placement_2': '500',
    'update_type_min_price_placement_2': 'value',
    'update_value_min_price_placement_2': null,
    'update_max_price_placement_2': null,
    'update_type_max_price_placement_2': 'value',
    'update_value_max_price_placement_2': null,
    'default_cpc_placement_2': '',
    'cpc_range_placement_2': null,
    'cpc_type_placement_2': 'keyword',
    'action_placement_5': 'reduce',
    'update_price_type_placement_5': 'value',
    'update_price_value_placement_5': '20',
    'update_min_price_placement_5': '500',
    'update_type_min_price_placement_5': 'value',
    'update_value_min_price_placement_5': null,
    'update_max_price_placement_5': null,
    'update_type_max_price_placement_5': 'value',
    'update_value_max_price_placement_5': null,
    'default_cpc_placement_5': '',
    'cpc_range_placement_5': null,
    'cpc_type_placement_5': 'keyword'
  }, {
    'condition_group': [{
      'condition_list': [{
        'label': 'avg_rank',
        'expression': '>',
        'value': '5',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'broad_cir',
        'expression': '<=',
        'value': '12',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }]
    }],
    'condition_list': [{
      'label': '',
      'expression': '',
      'value': '',
      'value_p': '',
      'value_t': [],
      'match_type': 'all',
      'post_expression': '&&',
      'level': '',
      'time': '',
      'time_range': null
    }],
    'action': '',
    'update_price_type': 'value',
    'update_price_value': '',
    'default_cpc': '',
    'cpc_range': null,
    'error_msg': '',
    'success_msg': '',
    'action_campaign': '',
    'update_price_type_campaign': 'value',
    'update_price_value_campaign': '20',
    'update_min_price_campaign': null,
    'update_max_price_campaign': null,
    'default_cpc_campaign': '',
    'cpc_range_campaign': null,
    'cpc_type_campaign': 'campaign',
    'action_match_type_0': 'increase',
    'update_price_type_match_type_0': 'value',
    'update_price_value_match_type_0': '50',
    'update_min_price_match_type_0': '1250',
    'update_type_min_price_match_type_0': 'value',
    'update_value_min_price_match_type_0': null,
    'update_max_price_match_type_0': 2500,
    'update_type_max_price_match_type_0': 'value',
    'update_value_max_price_match_type_0': null,
    'default_cpc_match_type_0': '',
    'cpc_range_match_type_0': null,
    'cpc_type_match_type_0': 'keyword',
    'action_match_type_1': 'increase',
    'update_price_type_match_type_1': 'value',
    'update_price_value_match_type_1': '50',
    'update_min_price_match_type_1': '1250',
    'update_type_min_price_match_type_1': 'value',
    'update_value_min_price_match_type_1': null,
    'update_max_price_match_type_1': 2000,
    'update_type_max_price_match_type_1': 'value',
    'update_value_max_price_match_type_1': null,
    'default_cpc_match_type_1': '',
    'cpc_range_match_type_1': null,
    'cpc_type_match_type_1': 'keyword',
    'action_placement_2': 'increase',
    'update_price_type_placement_2': 'value',
    'update_price_value_placement_2': 15,
    'update_min_price_placement_2': '750',
    'update_type_min_price_placement_2': 'value',
    'update_value_min_price_placement_2': null,
    'update_max_price_placement_2': 1250,
    'update_type_max_price_placement_2': 'value',
    'update_value_max_price_placement_2': null,
    'default_cpc_placement_2': '',
    'cpc_range_placement_2': null,
    'cpc_type_placement_2': 'keyword',
    'action_placement_5': 'increase',
    'update_price_type_placement_5': 'value',
    'update_price_value_placement_5': 15,
    'update_min_price_placement_5': '750',
    'update_type_min_price_placement_5': 'value',
    'update_value_min_price_placement_5': null,
    'update_max_price_placement_5': 1250,
    'update_type_max_price_placement_5': 'value',
    'update_value_max_price_placement_5': null,
    'default_cpc_placement_5': '',
    'cpc_range_placement_5': null,
    'cpc_type_placement_5': 'keyword'
  }, {
    'condition_group': [{
      'condition_list': [{
        'label': 'avg_rank',
        'expression': '<',
        'value': '6',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'broad_cir',
        'expression': '>',
        'value': '12',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }]
    }],
    'condition_list': [{
      'label': '',
      'expression': '',
      'value': '',
      'value_p': '',
      'value_t': [],
      'match_type': 'all',
      'post_expression': '&&',
      'level': '',
      'time': '',
      'time_range': null
    }],
    'action': '',
    'update_price_type': 'value',
    'update_price_value': '',
    'default_cpc': '',
    'cpc_range': null,
    'error_msg': '',
    'success_msg': '',
    'action_campaign': '',
    'update_price_type_campaign': 'value',
    'update_price_value_campaign': '20',
    'update_min_price_campaign': null,
    'update_max_price_campaign': null,
    'default_cpc_campaign': '',
    'cpc_range_campaign': null,
    'cpc_type_campaign': 'campaign',
    'action_match_type_0': 'reduce',
    'update_price_type_match_type_0': 'value',
    'update_price_value_match_type_0': '10',
    'update_min_price_match_type_0': '750',
    'update_type_min_price_match_type_0': 'value',
    'update_value_min_price_match_type_0': null,
    'update_max_price_match_type_0': null,
    'update_type_max_price_match_type_0': 'value',
    'update_value_max_price_match_type_0': null,
    'default_cpc_match_type_0': '',
    'cpc_range_match_type_0': null,
    'cpc_type_match_type_0': 'keyword',
    'action_match_type_1': 'reduce',
    'update_price_type_match_type_1': 'value',
    'update_price_value_match_type_1': '10',
    'update_min_price_match_type_1': '750',
    'update_type_min_price_match_type_1': 'value',
    'update_value_min_price_match_type_1': null,
    'update_max_price_match_type_1': null,
    'update_type_max_price_match_type_1': 'value',
    'update_value_max_price_match_type_1': null,
    'default_cpc_match_type_1': '',
    'cpc_range_match_type_1': null,
    'cpc_type_match_type_1': 'keyword',
    'action_placement_2': 'reduce',
    'update_price_type_placement_2': 'value',
    'update_price_value_placement_2': '10',
    'update_min_price_placement_2': '550',
    'update_type_min_price_placement_2': 'value',
    'update_value_min_price_placement_2': null,
    'update_max_price_placement_2': null,
    'update_type_max_price_placement_2': 'value',
    'update_value_max_price_placement_2': null,
    'default_cpc_placement_2': '',
    'cpc_range_placement_2': null,
    'cpc_type_placement_2': 'keyword',
    'action_placement_5': 'reduce',
    'update_price_type_placement_5': 'value',
    'update_price_value_placement_5': '10',
    'update_min_price_placement_5': '550',
    'update_type_min_price_placement_5': 'value',
    'update_value_min_price_placement_5': null,
    'update_max_price_placement_5': null,
    'update_type_max_price_placement_5': 'value',
    'update_value_max_price_placement_5': null,
    'default_cpc_placement_5': '',
    'cpc_range_placement_5': null,
    'cpc_type_placement_5': 'keyword'
  }, {
    'condition_group': [{
      'condition_list': [{
        'label': 'cost',
        'expression': '>',
        'value': '30000',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }, {
        'label': 'broad_cir',
        'expression': '===',
        'value': '0',
        'value_p': '',
        'value_t': [],
        'match_type': 'all',
        'post_expression': '&&',
        'level': 'detail',
        'time': 'today',
        'time_range': null
      }]
    }],
    'condition_list': [{
      'label': '',
      'expression': '',
      'value': '',
      'value_p': '',
      'value_t': [],
      'match_type': 'all',
      'post_expression': '&&',
      'level': '',
      'time': '',
      'time_range': null
    }],
    'action': '',
    'update_price_type': 'value',
    'update_price_value': '',
    'default_cpc': '',
    'cpc_range': null,
    'error_msg': '',
    'success_msg': '',
    'action_campaign': '',
    'update_price_type_campaign': 'value',
    'update_price_value_campaign': '20',
    'update_min_price_campaign': null,
    'update_max_price_campaign': null,
    'default_cpc_campaign': '',
    'cpc_range_campaign': null,
    'cpc_type_campaign': 'campaign',
    'action_match_type_0': 'value',
    'update_price_type_match_type_0': 'value',
    'update_price_value_match_type_0': '480',
    'update_min_price_match_type_0': '750',
    'update_type_min_price_match_type_0': 'value',
    'update_value_min_price_match_type_0': null,
    'update_max_price_match_type_0': null,
    'update_type_max_price_match_type_0': 'value',
    'update_value_max_price_match_type_0': null,
    'default_cpc_match_type_0': '',
    'cpc_range_match_type_0': null,
    'cpc_type_match_type_0': 'keyword',
    'action_match_type_1': 'value',
    'update_price_type_match_type_1': 'value',
    'update_price_value_match_type_1': '480',
    'update_min_price_match_type_1': '750',
    'update_type_min_price_match_type_1': 'value',
    'update_value_min_price_match_type_1': null,
    'update_max_price_match_type_1': null,
    'update_type_max_price_match_type_1': 'value',
    'update_value_max_price_match_type_1': null,
    'default_cpc_match_type_1': '',
    'cpc_range_match_type_1': null,
    'cpc_type_match_type_1': 'keyword',
    'action_placement_2': 'value',
    'update_price_type_placement_2': 'value',
    'update_price_value_placement_2': '480',
    'update_min_price_placement_2': '550',
    'update_type_min_price_placement_2': 'value',
    'update_value_min_price_placement_2': null,
    'update_max_price_placement_2': null,
    'update_type_max_price_placement_2': 'value',
    'update_value_max_price_placement_2': null,
    'default_cpc_placement_2': '',
    'cpc_range_placement_2': null,
    'cpc_type_placement_2': 'keyword',
    'action_placement_5': 'value',
    'update_price_type_placement_5': 'value',
    'update_price_value_placement_5': '480',
    'update_min_price_placement_5': '550',
    'update_type_min_price_placement_5': 'value',
    'update_value_min_price_placement_5': null,
    'update_max_price_placement_5': null,
    'update_type_max_price_placement_5': 'value',
    'update_value_max_price_placement_5': null,
    'default_cpc_placement_5': '',
    'cpc_range_placement_5': null,
    'cpc_type_placement_5': 'keyword'
  }]
}

export const template_auto_quota = {
  "name": "Tối ưu ngân sách theo CIR",
  "level": "campaign",
  "advanced_day": "remain",
  "advanced_day_number": null,
  "radio": "1",
  "time": "",
  "start_time": "",
  "end_time": "",
  "times": [],
  "not_in": {
    "action_campaign": "",
    "update_price_type_campaign": "value",
    "update_price_value_campaign": "",
    "update_min_price_campaign": null,
    "update_max_price_campaign": null,
    "default_cpc_campaign": "",
    "cpc_range_campaign": null,
    "cpc_type_campaign": "campaign",
    "action_match_type_0": "",
    "update_price_type_match_type_0": "value",
    "update_price_value_match_type_0": "",
    "update_min_price_match_type_0": null,
    "update_type_min_price_match_type_0": "value",
    "update_value_min_price_match_type_0": null,
    "update_max_price_match_type_0": null,
    "update_type_max_price_match_type_0": "value",
    "update_value_max_price_match_type_0": null,
    "default_cpc_match_type_0": "",
    "cpc_range_match_type_0": null,
    "cpc_type_match_type_0": "keyword",
    "action_match_type_1": "",
    "update_price_type_match_type_1": "value",
    "update_price_value_match_type_1": "",
    "update_min_price_match_type_1": null,
    "update_type_min_price_match_type_1": "value",
    "update_value_min_price_match_type_1": null,
    "update_max_price_match_type_1": null,
    "update_type_max_price_match_type_1": "value",
    "update_value_max_price_match_type_1": null,
    "default_cpc_match_type_1": "",
    "cpc_range_match_type_1": null,
    "cpc_type_match_type_1": "keyword",
    "action_placement_2": "",
    "update_price_type_placement_2": "value",
    "update_price_value_placement_2": "",
    "update_min_price_placement_2": null,
    "update_type_min_price_placement_2": "value",
    "update_value_min_price_placement_2": null,
    "update_max_price_placement_2": null,
    "update_type_max_price_placement_2": "value",
    "update_value_max_price_placement_2": null,
    "default_cpc_placement_2": "",
    "cpc_range_placement_2": null,
    "cpc_type_placement_2": "keyword",
    "action_placement_5": "",
    "update_price_type_placement_5": "value",
    "update_price_value_placement_5": "",
    "update_min_price_placement_5": null,
    "update_type_min_price_placement_5": "value",
    "update_value_min_price_placement_5": null,
    "update_max_price_placement_5": null,
    "update_type_max_price_placement_5": "value",
    "update_value_max_price_placement_5": null,
    "default_cpc_placement_5": "",
    "cpc_range_placement_5": null,
    "cpc_type_placement_5": "keyword"
  },
  "condition_action_list": [{
    "condition_group": [{
      "condition_list": [{
        "label": "cost_x_budget",
        "expression": ">=",
        "value": "70",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }, {
        "label": "broad_cir",
        "expression": ">",
        "value": "0",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }, {
        "label": "broad_cir",
        "expression": "<=",
        "value": "15",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }]
    }],
    "condition_list": [],
    "action": "",
    "update_price_type": "value",
    "update_price_value": "",
    "default_cpc": "",
    "cpc_range": null,
    "error_msg": "",
    "success_msg": "",
    "action_campaign": "increase",
    "update_price_type_campaign": "percent",
    "update_price_value_campaign": "40",
    "update_min_price_campaign": null,
    "update_max_price_campaign": null,
    "default_cpc_campaign": "",
    "cpc_range_campaign": null,
    "cpc_type_campaign": "campaign",
    "action_match_type_0": "",
    "update_price_type_match_type_0": "value",
    "update_price_value_match_type_0": "",
    "update_min_price_match_type_0": null,
    "update_type_min_price_match_type_0": "value",
    "update_value_min_price_match_type_0": null,
    "update_max_price_match_type_0": null,
    "update_type_max_price_match_type_0": "value",
    "update_value_max_price_match_type_0": null,
    "default_cpc_match_type_0": "",
    "cpc_range_match_type_0": null,
    "cpc_type_match_type_0": "keyword",
    "action_match_type_1": "",
    "update_price_type_match_type_1": "value",
    "update_price_value_match_type_1": "",
    "update_min_price_match_type_1": null,
    "update_type_min_price_match_type_1": "value",
    "update_value_min_price_match_type_1": null,
    "update_max_price_match_type_1": null,
    "update_type_max_price_match_type_1": "value",
    "update_value_max_price_match_type_1": null,
    "default_cpc_match_type_1": "",
    "cpc_range_match_type_1": null,
    "cpc_type_match_type_1": "keyword",
    "action_placement_2": "",
    "update_price_type_placement_2": "value",
    "update_price_value_placement_2": "",
    "update_min_price_placement_2": null,
    "update_type_min_price_placement_2": "value",
    "update_value_min_price_placement_2": null,
    "update_max_price_placement_2": null,
    "update_type_max_price_placement_2": "value",
    "update_value_max_price_placement_2": null,
    "default_cpc_placement_2": "",
    "cpc_range_placement_2": null,
    "cpc_type_placement_2": "keyword",
    "action_placement_5": "",
    "update_price_type_placement_5": "value",
    "update_price_value_placement_5": "",
    "update_min_price_placement_5": null,
    "update_type_min_price_placement_5": "value",
    "update_value_min_price_placement_5": null,
    "update_max_price_placement_5": null,
    "update_type_max_price_placement_5": "value",
    "update_value_max_price_placement_5": null,
    "default_cpc_placement_5": "",
    "cpc_range_placement_5": null,
    "cpc_type_placement_5": "keyword"
  }, {
    "condition_group": [{
      "condition_list": [{
        "label": "broad_cir",
        "expression": "===",
        "value": "0",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }, {
        "label": "cost",
        "expression": ">=",
        "value": "50000",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }]
    }, {
      "condition_list": [{
        "label": "broad_cir",
        "expression": ">",
        "value": "15",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }]
    }],
    "condition_list": [{
      "label": "",
      "expression": "",
      "value": "",
      "value_p": "",
      "value_t": [],
      "match_type": "all",
      "post_expression": "&&",
      "level": "",
      "time": "",
      "time_range": null
    }],
    "action": "",
    "update_price_type": "value",
    "update_price_value": "",
    "default_cpc": "",
    "cpc_range": null,
    "error_msg": "",
    "success_msg": "",
    "action_campaign": "set_by_cost",
    "update_price_type_campaign": "value",
    "update_price_value_campaign": "100000",
    "update_min_price_campaign": null,
    "update_max_price_campaign": null,
    "default_cpc_campaign": "",
    "cpc_range_campaign": null,
    "cpc_type_campaign": "campaign",
    "action_match_type_0": "",
    "update_price_type_match_type_0": "value",
    "update_price_value_match_type_0": "",
    "update_min_price_match_type_0": null,
    "update_type_min_price_match_type_0": "value",
    "update_value_min_price_match_type_0": null,
    "update_max_price_match_type_0": null,
    "update_type_max_price_match_type_0": "value",
    "update_value_max_price_match_type_0": null,
    "default_cpc_match_type_0": "",
    "cpc_range_match_type_0": null,
    "cpc_type_match_type_0": "keyword",
    "action_match_type_1": "",
    "update_price_type_match_type_1": "value",
    "update_price_value_match_type_1": "",
    "update_min_price_match_type_1": null,
    "update_type_min_price_match_type_1": "value",
    "update_value_min_price_match_type_1": null,
    "update_max_price_match_type_1": null,
    "update_type_max_price_match_type_1": "value",
    "update_value_max_price_match_type_1": null,
    "default_cpc_match_type_1": "",
    "cpc_range_match_type_1": null,
    "cpc_type_match_type_1": "keyword",
    "action_placement_2": "",
    "update_price_type_placement_2": "value",
    "update_price_value_placement_2": "",
    "update_min_price_placement_2": null,
    "update_type_min_price_placement_2": "value",
    "update_value_min_price_placement_2": null,
    "update_max_price_placement_2": null,
    "update_type_max_price_placement_2": "value",
    "update_value_max_price_placement_2": null,
    "default_cpc_placement_2": "",
    "cpc_range_placement_2": null,
    "cpc_type_placement_2": "keyword",
    "action_placement_5": "",
    "update_price_type_placement_5": "value",
    "update_price_value_placement_5": "",
    "update_min_price_placement_5": null,
    "update_type_min_price_placement_5": "value",
    "update_value_min_price_placement_5": null,
    "update_max_price_placement_5": null,
    "update_type_max_price_placement_5": "value",
    "update_value_max_price_placement_5": null,
    "default_cpc_placement_5": "",
    "cpc_range_placement_5": null,
    "cpc_type_placement_5": "keyword"
  }, /*{
    "condition_group": [{
      "condition_list": [{
        "label": "cost",
        "expression": "<=xcost",
        "value": "30",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }, {
        "label": "cost",
        "expression": ">",
        "value": "50000",
        "value_p": "",
        "value_t": [],
        "match_type": "all",
        "post_expression": "&&",
        "level": "campaign",
        "time": "today",
        "time_range": null
      }]
    }],
    "condition_list": [{
      "label": "",
      "expression": "",
      "value": "",
      "value_p": "",
      "value_t": [],
      "match_type": "all",
      "post_expression": "&&",
      "level": "",
      "time": "",
      "time_range": null
    }],
    "action": "",
    "update_price_type": "value",
    "update_price_value": "",
    "default_cpc": "",
    "cpc_range": null,
    "error_msg": "",
    "success_msg": "",
    "action_campaign": "value",
    "update_price_type_campaign": "value",
    "update_price_value_campaign": "50000",
    "update_min_price_campaign": null,
    "update_max_price_campaign": null,
    "default_cpc_campaign": "",
    "cpc_range_campaign": null,
    "cpc_type_campaign": "campaign",
    "action_match_type_0": "",
    "update_price_type_match_type_0": "value",
    "update_price_value_match_type_0": "",
    "update_min_price_match_type_0": null,
    "update_type_min_price_match_type_0": "value",
    "update_value_min_price_match_type_0": null,
    "update_max_price_match_type_0": null,
    "update_type_max_price_match_type_0": "value",
    "update_value_max_price_match_type_0": null,
    "default_cpc_match_type_0": "",
    "cpc_range_match_type_0": null,
    "cpc_type_match_type_0": "keyword",
    "action_match_type_1": "",
    "update_price_type_match_type_1": "value",
    "update_price_value_match_type_1": "",
    "update_min_price_match_type_1": null,
    "update_type_min_price_match_type_1": "value",
    "update_value_min_price_match_type_1": null,
    "update_max_price_match_type_1": null,
    "update_type_max_price_match_type_1": "value",
    "update_value_max_price_match_type_1": null,
    "default_cpc_match_type_1": "",
    "cpc_range_match_type_1": null,
    "cpc_type_match_type_1": "keyword",
    "action_placement_2": "",
    "update_price_type_placement_2": "value",
    "update_price_value_placement_2": "",
    "update_min_price_placement_2": null,
    "update_type_min_price_placement_2": "value",
    "update_value_min_price_placement_2": null,
    "update_max_price_placement_2": null,
    "update_type_max_price_placement_2": "value",
    "update_value_max_price_placement_2": null,
    "default_cpc_placement_2": "",
    "cpc_range_placement_2": null,
    "cpc_type_placement_2": "keyword",
    "action_placement_5": "",
    "update_price_type_placement_5": "value",
    "update_price_value_placement_5": "",
    "update_min_price_placement_5": null,
    "update_type_min_price_placement_5": "value",
    "update_value_min_price_placement_5": null,
    "update_max_price_placement_5": null,
    "update_type_max_price_placement_5": "value",
    "update_value_max_price_placement_5": null,
    "default_cpc_placement_5": "",
    "cpc_range_placement_5": null,
    "cpc_type_placement_5": "keyword"
  }*/
  ]
}



// WEBPACK FOOTER //
// ./src/pages/pas/script/template_config.js